import { PermissionType } from '../../types/common';

import { getSubjectPermission } from './getSubjectsFromPermissions';

export default (permissions: string[], subjectKey: string, categoryTag: string) => {
  const subjectPermission = getSubjectPermission(subjectKey, categoryTag);
  return permissions.includes(subjectPermission)
  || permissions.includes(`${PermissionType.Base}_${categoryTag}`)
  || permissions.includes(PermissionType.Base);
};
